import type * as React from 'react';

import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '../lib/utils';

type Props = React.ComponentProps<typeof SwitchPrimitive.Root>;

function Switch({ className, ...props }: Props) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                'peer inline-flex h-5 w-9 shrink-0 items-center',
                'rounded-full border-2 border-transparent',
                'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80',
                'transition-colors outline-none',
                'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
                'cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    'pointer-events-none block size-4 rounded-full',
                    'bg-background shadow-lg ring-0',
                    'transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
                )}
            />
        </SwitchPrimitive.Root>
    );
}

export { Switch };
